<template>
    <aside class="nav-new-drawer">
        <header class="drawer-header">
            <div class="drawer-title-group">
                <Icon :name="drawer.icon" class="drawer-title-icon" />
                <h2 class="drawer-title">{{ drawer.label }}</h2>
            </div>
            <button class="drawer-close-btn" @click="$emit('close')" title="Close drawer">
                <Icon name="chevron-left" />
            </button>
        </header>
        <div class="drawer-content">
            <!-- Placeholder for additional routing/options for each section -->
            <div
                v-for="(links, group) in groupedLinks"
                :key="group"
                class="drawer-group-container"
            >
                <h3 v-if="group" class="drawer-group-header">{{ group }}</h3>
                <ul class="drawer-links">
                    <li
                        v-for="(link, index) in links"
                        :key="index"
                        class="drawer-nav-item"
                    >
                        <control :name="link.name"></control>
                    </li>
                </ul>
            </div>
        </div>
    </aside>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import Icon from '@common/icon/Icon.vue';
import control from '@common/control/control';

const props = defineProps({
    drawer: {
        type: Object,
        required: true
    }
});

const { drawer } = toRefs(props);

defineEmits(['close', 'navigate']);

const groupedLinks = computed(() => drawer?.value?.links?.reduce?.((acc, item) => {
    (acc[item.section] ??= []).push(item);
    return acc;
}, {}));

</script>

<style scoped>
.nav-new-drawer {
    width: 260px;
    max-width: 280px;
    height: 100%;
    border-left: 1px solid #e0e0e0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 8px rgba(15, 23, 42, 0.06);
    animation: slideIn 0.18s ease-out;
}

.drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e0e0e0;
}

.drawer-title-group {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.drawer-title-icon {
    color: #6b7280;
}

.drawer-group-container {
    padding: 1rem 0;
}

.drawer-group-container:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
}

.drawer-group-header {
    margin: 0;
    padding-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
}

.drawer-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
}

.drawer-close-btn {
    border: none;
    background: none;
    cursor: pointer;
    color: #6b7280;
    border-radius: 999px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.drawer-close-btn:hover {
    background-color: #f3f4f6;
    color: #111827;
}

.drawer-content {
    padding: 0.75rem 1rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    overflow-y: auto;
}

.drawer-links {
    list-style: none;
    margin: 0.25rem 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.drawer-link-btn {
    width: 100%;
    text-align: left;
    font-size: 1rem;
    white-space: nowrap;
    padding: 0.75rem 1rem;
    border-radius: 6px;
    border: none;
    background: none;
    cursor: pointer;
    color: #495057;
    transition: background-color 0.2s, color 0.2s;
}

.drawer-link-btn:hover {
    background-color: #f3f4f6;
    color: #111827;
}

@keyframes slideIn {
    from {
        transform: translateX(-8px);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>
